import React from 'react'
import { Box } from '@mui/material'

const UIPaper = ({ sx, children, ...props }) => {
  return (
    <Box
      sx={{
        p: '30px',
        borderRadius: '6px',
        boxShadow: '0 0 24px 0 rgba(0,0,0,.1)',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  )
}

export default UIPaper
